// extracted by mini-css-extract-plugin
export default {"box":"icon-module__box___3d96e3","svg":"icon-module__svg___42cea2"};